
// Vue
import {Options, Vue} from "vue-class-component";

// Components
import {
  ElRow,
  ElCol,
} from "element-plus";
import CoachNavigationVue from "@/components/coach/navigation.vue";
import CoachResourcesNavigationVue from "@/components/coach/resources/navigation.vue";
import AppCoachResourcesExercisesListIndexVue from "@/views/app/coach/resources/exercises/list/index.vue";

@Options({
  components: {
    ElRow,
    ElCol,
    CoachNavigationVue,
    CoachResourcesNavigationVue,
    AppCoachResourcesExercisesListIndexVue,
  },
})
export default class AppCoachResourcesExercisesIndexVue extends Vue {}
